import Route from '@ember/routing/route';

export interface SharedArtifactModel {
	shareToken: string;
}

export default class SharedArtifactRoute extends Route {
	override beforeModel(): void {
		document.body.id = 'page-shared-artifact';
	}

	override model(params: { share_token: string }): SharedArtifactModel {
		const { share_token } = params;
		return { shareToken: share_token };
	}
}
